import { createIcon } from './createIcon'

export const SearchIcon = createIcon({
  displayName: 'SearchIcon',
  viewBox: '0 0 16 17',
  path: [
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00125 2.9866C3.79211 2.9865 2.00117 4.77728 2.00107 6.98642C2.00097 9.19556 3.79176 10.9865 6.00089 10.9866C8.21003 10.9867 10.001 9.19592 10.0011 6.98678C10.0012 4.77764 8.21039 2.9867 6.00125 2.9866ZM0.00107369 6.98633C0.0012223 3.67262 2.68763 0.986449 6.00134 0.986597C9.31505 0.986746 12.0012 3.67316 12.0011 6.98687C12.001 8.2827 11.5902 9.48256 10.8917 10.4634L15.7078 15.2799C16.0983 15.6705 16.0983 16.3036 15.7077 16.6941C15.3172 17.0846 14.684 17.0846 14.2935 16.6941L9.47739 11.8775C8.49654 12.5759 7.29663 12.9867 6.0008 12.9866C2.6871 12.9864 0.000925084 10.3 0.00107369 6.98633Z"
      fill="currentColor"
    />,
  ],
})
